import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import { usePlatformSettings } from "@/hooks/usePlatformSettings";

// Lazy-load PricingPage so Stripe (@stripe/react-stripe-js + injected
// stripe.js script) is not pulled into the main landing-page bundle.
const PricingPage = lazy(() => import("@/pages/PricingPage"));

/** Renders the public pricing page only when pricing is globally enabled. */
export function PricingRouteGate() {
  const { pricingEnabled, loading } = usePlatformSettings();
  if (loading) return null;
  if (!pricingEnabled) return <Navigate to="/" replace />;
  return (
    <Suspense fallback={null}>
      <PricingPage />
    </Suspense>
  );
}